export const ACCESS_TOKEN = 'accessToken';
export const PUBLIC_URL = process.env.PUBLIC_URL || 'http://localhost:3000';
export const PURCHASE_CHANNEL = "web-app";
export const SAMAN_EPAY_URL= process.env.NODE_ENV === 'production' ?
    "https://api.myroro.ir/Mobilepg/Mobilepayment" :
    "https://api.myroro.ir/Mobilepg/Mobilepayment";
export const STATIC_MAP_URL = "https://api.neshan.org/v2/static?key=service.SUhfgQ66S212ZYeM4uxG0F8ZnKrcRxIKsZZJP5PH&type=standard-day&zoom=14&width=508&height=285&marker=green&center={0},{1}";
export const defaultAmount = 90000